import React, {useEffect} from "react";

import { Container } from "../../components/Container";
import { Welcome } from "../../screens/Welcome";
import { InvalidLink } from "../../screens/InvalidLink";
import { Agreement } from "../../screens/Agreement";
import { Registration } from "../../screens/Registration";
import { Anthropometry } from "../../screens/Anthropometry";
import { Allergens } from "../../screens/Allergens";
import { RegistrationSuccess } from "../../screens/RegistrationSuccess";
import { Dietanamnez } from "../../screens/Dietanamnez";
import { DietanamnezTiles } from "../../screens/DietanamnezTiles";
import { Deficit } from "screens/Deficit";
import { Product } from "screens/Product";
import { Supplement } from "screens/Supplement";
import { Finish } from "../../screens/Finish";
import { TelegramError } from "../../screens/AndroidVebView";
import { EmailScreen } from "../../screens/EmailScreen";
import { PhoneAndEmailScreen } from "../../screens/PhoneAndEmailScreen";

import { StateManagerContext, useStateManager } from "utils/useStateManager";

export const Root: React.FC<{}> = () => {
  const stateManager = useStateManager();
  const { userType, screen, linkInfo, onPrevScreen, onNextScreen } = stateManager;
  const isEpharmacy = linkInfo?.custom?.custom_генерировать_бад_рацион_при_саморегистрации;
  const showProducts = linkInfo?.custom?.custom_показывать_экран_рекомендуемая_продукция;
  const miratorgData = linkInfo?.custom?.custom_additional_data?.final_screen_additional_content;
  const showEmailButton = linkInfo?.custom?.custom_показывать_кнопку_полный_отчет_на_почту;
  const showDownloadButton =  linkInfo?.custom?.custom_показывать_кнопку_скачать_отчет;

  if (!screen) {
    return null;
  }

  const screensList = isEpharmacy ?
    {
      ERROR: <InvalidLink userType={userType} />,
      ERROR_TELEGRAM: <TelegramError />,
      WELCOME: <Welcome onSubmit={onNextScreen} />,
      REGISTRATION_SUCCESS: <RegistrationSuccess onSubmit={onNextScreen} />,
      DIETANAMNEZ: <Dietanamnez onBack={onPrevScreen} onSubmit={onNextScreen} />,
      DIETANAMNEZ_TILES: (
        <DietanamnezTiles onBack={onPrevScreen} onSubmit={onNextScreen} />
      ),
      PHONE_AND_EMAIL: <PhoneAndEmailScreen onSubmit={onNextScreen} />,
      REGISTRATION: <Registration onSubmit={onNextScreen} />,
      DEFICIT: <Deficit onSubmit={onNextScreen} />,
      PRODUCT: <Product onSubmit={onNextScreen} showProducts={showProducts} miratorgData={miratorgData} showEmailButton={showEmailButton} showDownloadButton={showDownloadButton}/>,
      EMAIL_SCREEN: <EmailScreen onBack={onPrevScreen}/>
    } :
    {
      ERROR: <InvalidLink userType={userType} />,
      ERROR_TELEGRAM: <TelegramError />,
      WELCOME: <Welcome onSubmit={onNextScreen} />,
      REGISTRATION_SUCCESS: <RegistrationSuccess onSubmit={onNextScreen} />,
      DIETANAMNEZ: <Dietanamnez onBack={onPrevScreen} onSubmit={onNextScreen} />,
      DIETANAMNEZ_TILES: (
        <DietanamnezTiles onBack={onPrevScreen} onSubmit={onNextScreen} />
      ),
      ALLERGENS: <Allergens onBack={onPrevScreen} onSubmit={onNextScreen} />,
      AGREEMENT: <Agreement onSubmit={onNextScreen} />,
      REGISTRATION: <Registration onSubmit={onNextScreen} />,
      ANTHROPOMETRY: (
        <Anthropometry onBack={onPrevScreen} onSubmit={onNextScreen} />
      ),
      SUPPLEMENT: <Supplement onBack={onPrevScreen} onSubmit={onNextScreen} />,
      FINISH: <Finish />,
    };

  return (
    <StateManagerContext.Provider value={stateManager}>
      <Container>{screensList[screen!]}</Container>
    </StateManagerContext.Provider>
  );
};
